import { Box, Center } from '@chakra-ui/react';
import { PossibleEnrichments } from '@outdoorly/chat-sdk';
import React, { useRef, useState } from 'react';
import { tryToBuildImgixUrl } from '../../utils/imgix';
import { RemarkCarousel } from '../Carousel';
import { ChatHeader } from '../ChatHeader';
import { MotionBox } from '../Motion';
import { SkeletonImage } from '../SkeletonImage';

type RemarkGalleryProps = {
  gallery?: NonNullable<NonNullable<PossibleEnrichments['expert']>['expertProfile']>['gallery'];
  galleryIndex?: number;
  expertProfile: NonNullable<PossibleEnrichments['expert']>['expertProfile'];
};
export const RemarkGallery: React.FC<RemarkGalleryProps> = (props) => {
  const { gallery, galleryIndex, expertProfile } = props;
  const leftButtonRef = useRef<null | HTMLButtonElement>(null);

  const slides = gallery?.map((galleryPhoto) => (
    <Box key={galleryPhoto.id} listStyleType="none" h="100%" w="100%">
      <Center h="calc(100vh - 20px)" zIndex={'modal'}>
        <SkeletonImage
          src={tryToBuildImgixUrl(galleryPhoto.url, {
            h: 600,
            w: 400,
            auto: 'format,compress'
          })}
          imageProps={{
            objectFit: 'contain',
            height: '100%',
            width: '100%',
            sx: {
              WebkitUserDrag: 'none',
              WebkitUserSelect: 'none'
            },
            role: 'presentation'
          }}
        />
      </Center>
      <Box
        _after={{
          width: '100%',
          height: '100%',
          background: 'linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3))',
          content: "''",
          position: 'absolute',
          top: 0,
          display: 'block',
          zIndex: -1
        }}
      >
        <SkeletonImage
          src={tryToBuildImgixUrl(galleryPhoto.url, {
            h: 200,
            w: 200,
            auto: 'format,compress'
          })}
          imageProps={{
            objectFit: 'cover',
            height: 'calc(100vh - 20px)',
            width: '100vw',
            sx: {
              WebkitUserDrag: 'none',
              WebkitUserSelect: 'none'
            },
            role: 'presentation',
            position: 'absolute',
            zIndex: -1,
            top: 0,
            filter: 'blur(6px)'
          }}
        />
      </Box>
    </Box>
  ));
  return (
    <MotionBox animate={{ scale: 1 }} initial={{ scale: 0.3 }} exit={{ opacity: 0 }} pos="relative">
      <RemarkCarousel
        leftButtonRef={leftButtonRef}
        frameAriaLabel="expert gallery photos"
        focusable={true}
        slideIndex={galleryIndex}
        slidesToShow={1}
        slides={slides ?? []}
        slidesToScroll={1}
        cellSpacing={0}
        hideBullets
        wrapAround
        overflow="visible"
      />
      <ChatHeader
        pos="absolute"
        hideButtons
        expertProfile={expertProfile}
        bottom={'12px'}
        left="12px"
        borderRadius="8px"
        w="calc(100% - 24px)"
      />
    </MotionBox>
  );
};
